import { isEmpty } from '.';
import { convertStringFieldsToDate } from './format';

const dateFields = {
  stepApplication: {
    dateIdentified: '',
    dateAssigned: '',
    dateInvited: '',
    dateAttended: '',
    dateCollected: '',
    dateSubmitted: '',
    dateSubmissionCompleted: '',
  },
  stepFramework: {
    dateOfDSDSiteVisit: '',
    exportPDFTitle: {
      dateVisit: '',
    },
  },
  stepAssessment: {
    certificateExpiryDate: '',
    certificateIssueDate: '',
    dateCertificateReceivedFromDistrict: '',
    dateFileCompilationSubmitted: '',
    dateOfDSDSiteVisit: '',
    dateOfEHPSiteVisit: '',
    dateEHPReportReceived: '',
    dateCertificateDispensed: '',
    dateProgCertificateDispensed: '',
    dateProgCertificateReceivedFromDistrict: '',
    progCertificateExpiryDate: '',
    progCertificateIssueDate: '',
  },
};

class ECDRegistrationStorage {
  ecdRegistration: any;
  ecdRegistrationId: string;

  constructor(initialId: string, load?: boolean) {
    this.ecdRegistrationId = initialId;
    if (load || load === undefined) {
      const sessionData = window.sessionStorage.getItem(this.ecdRegistrationId);
      if (sessionData) {
        this.ecdRegistration = JSON.parse(sessionData);
        convertStringFieldsToDate(this.ecdRegistration, dateFields);
        return;
      }
    }
    this.ecdRegistration = {
      stepApplication: {},
      stepFramework: {},
      stepAssessment: {},
      stepApproval: {},
    };
  }

  initialized(): boolean {
    if (
      this.ecdRegistrationId &&
      !isEmpty(this.ecdRegistration) &&
      this.ecdRegistration.stepApplication &&
      !isEmpty(this.ecdRegistration.stepApplication)
    )
      return true;
    return false;
  }

  setECDRegistration(item: any) {
    window.sessionStorage.setItem(this.ecdRegistrationId, JSON.stringify(item));
    this.ecdRegistration = item;
  }

  setECDRegistrationId(id: string) {
    this.ecdRegistrationId = id;
    this.ecdRegistration.id = id;
    window.sessionStorage.setItem(this.ecdRegistrationId, JSON.stringify(this.ecdRegistration));
  }

  getECDRegistration() {
    return this.ecdRegistration;
  }

  setData(stepId: string, item: any) {
    if (stepId) {
      this.ecdRegistration[stepId] = item;
    } else {
      this.ecdRegistration = item;
    }
    window.sessionStorage.setItem(this.ecdRegistrationId, JSON.stringify(this.ecdRegistration));
    return this.ecdRegistration;
  }

  getData(stepId?: string): any {
    return stepId ? this.ecdRegistration[stepId] : this.ecdRegistration;
  }

  removeECDRegistration(ecdRegistrationId: string) {
    window.sessionStorage.removeItem(ecdRegistrationId);
    this.ecdRegistration = {
      stepApplication: {},
      stepFramework: {},
      stepAssessment: {},
      stepApproval: {},
    };
  }
}

export default ECDRegistrationStorage;
